import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import MeasurementCreate from '../../components/Measurement/MeasurementCreate';

const MeasurementCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <MeasurementCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default MeasurementCreatePage;